import React from 'react';
import { styled } from '@linaria/react';

import DefaultButton from '@/components/DefaultButton';

const random = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

// Default color is a bright yellow
const DEFAULT_COLOR = 'hsl(50deg, 100%, 50%)';

const generateSparkle = (color = DEFAULT_COLOR) => {
  return {
    id: String(random(10000, 99999)),
    createdAt: Date.now(),
    // Bright yellow color:
    color,
    size: 200,
  };
};

function SparkleInstance({ color, size, style }) {
  return (
    <AnimationWrapper>
      <Svg
        width={size}
        height={size}
        viewBox="0 0 160 160"
        fill="none"
        style={style}
      >
        <path
          d="M80 0C80 0 84.2846 41.2925 101.496 58.504C118.707 75.7154 160 80 160 80C160 80 118.707 84.2846 101.496 101.496C84.2846 118.707 80 160 80 160C80 160 75.7154 118.707 58.504 101.496C41.2925 84.2846 0 80 0 80C0 80 41.2925 75.7154 58.504 58.504C75.7154 41.2925 80 0 80 0Z"
          fill={color}
        />
      </Svg>
    </AnimationWrapper>
  );
}

function Sparkles({ children }) {
  const [sparkle, setSparkle] = React.useState(generateSparkle);

  return (
    <Wrapper>
      <SparkleInstance
        key={sparkle.id}
        color={sparkle.color}
        size={sparkle.size}
        style={sparkle.style}
      />
      <DefaultButton onClick={() => setSparkle(generateSparkle())}>
        Click me
      </DefaultButton>
    </Wrapper>
  );
}

const AnimationWrapper = styled.div`
  pointer-events: none;
  animation: scaleIn 600ms ease-in-out forwards;
  margin-bottom: -32px;

  @keyframes scaleIn {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
`;

const Svg = styled.svg`
  animation: spin 600ms linear forwards;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }
`;

const Wrapper = styled.span`
  position: relative;
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  border-radius: 6px;
  outline: 1px solid var(--color-gray-200);
`;

export default Sparkles;
